import { useCallback, useEffect } from 'react';
// @mui
import { Button, Card, Stack } from '@mui/material';
// redux
import { useDispatch, useSelector } from 'src/redux/store';
import { addReportTabel, getReportRows } from 'src/redux/slices/report';
// locale
import { useLocales } from 'src/locales';
// components
import ReportToolbar from 'src/components/report/report-toolbar';
import { ReportTableSkeleton } from 'src/components/report/report-table-skeleton';
import ReportEditTableElement from './report-edit-table-element';

export default function ReportEditBuilder() {
  const { t } = useLocales();

  const rows = useSelector((state) => state.report.rows);
  const report = useSelector((state) => state.report.report);
  const template = useSelector((state) => state.report.template);
  const filter = useSelector((state) => state.report.filter);
  const loading = useSelector((state) => state.report.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    if (filter.dataSource && filter.dataSource.length > 0) {
      dispatch(
        getReportRows({
          fromDate: filter.fromDate,
          toDate: filter.toDate,
          dataSource: filter.dataSource,
          templateId: null,
        })
      );
    }
  }, [dispatch, filter]);

  const handleAddTable = useCallback(() => {
    dispatch(addReportTabel({ table: template.tables![0] }));
  }, [dispatch, template]);

  return (
    <Stack spacing={3}>
      <Card>
        <ReportToolbar />
      </Card>
      {report.tables &&
        report.tables.map(
          (x, i) =>
            x.columns && (
              <ReportEditTableElement
                rows={rows}
                columns={x.columns}
                table={x as any}
                index={i}
                key={i}
                dataSource={filter.dataSource}
              />
            )
        )}
      {(!report.tables || report.tables.length === 0) && loading[0] && <ReportTableSkeleton />}
      <Stack direction="row" justifyContent="center" alignItems="center">
        <Button
          sx={{ px: 5 }}
          size="medium"
          variant="contained"
          onClick={handleAddTable}
          color="primary"
        >
          {t('Add new table')}
        </Button>
      </Stack>
    </Stack>
  );
}
